// extracted by mini-css-extract-plugin
export default {"header":"header_header__n-qNO","menu-wrapper":"header_menu-wrapper__BEqMv","logo":"header_logo__TzswS"};